import React from 'react';
import propTypes from 'prop-types';
import shortid from 'shortid';
import { ListGroup, ListGroupItem } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'utils/store/thirdPartyConnectToCanvasStore';
import classnames from 'classnames';
import { makeId } from 'utils/selectors';
import { versionStateMapper } from '../const';
import styles from './ComponentUsage.css';

/**
 * Returns MasterComponent component
 * @returns {React.Component} the MasterComponent component.
 */
const ComponentUsage = ({ usage, unboundVisitPage, unboundVisitComponent }) => {
  /**
   * Returns a list of components based on filter provided
   * @param {object} filteredList - filtered list based on component type
   * @param {object} title - title to display
   * @param {Function} onItemClick - function to be executed on click
   * @returns {React.Component} ListGroup React component
   */
  const separateUsageList = function separateUsageList(filteredList, title, onItemClick) {
    return (
      <div>
        <h3>{title}</h3>
        <ListGroup>
          {isEmpty(filteredList) && (
            <div data-test-id={makeId({ value: `empty-${title}` })}>N/A</div>
          )}
          {filteredList.map(filteredData => (
            <ListGroupItem className={styles.listItem} key={shortid.generate()}>
              <Link target="_blank" to={onItemClick(filteredData.Id, filteredData.Version)}>
                {`${filteredData.Name} (${versionStateMapper[filteredData.Version]})`}
              </Link>
            </ListGroupItem>
          ))}
          <hr />
        </ListGroup>
      </div>
    );
  };

  /**
   * Returns a list of usage
   * @returns {React.Component} ListGroup component
   */
  const renderUsageList = function renderUsageList() {
    if (!usage.error && !usage.data) {
      return (
        <div className="mt-5 mb-5">
          <em>Loading...</em>
        </div>
      );
    }
    if (usage.error) {
      return (
        <div className={classnames('mt-5 mb-5', styles.failed)}>{`** ${usage.error} **`}</div>
      );
    }
    const pageTypefilter = usage.data.filter(usageObject => usageObject.Type === 'page');
    const componentTypefilter = usage.data.filter(
      usageObject => usageObject.Type === 'component'
    );
    return (
      <div>
        {separateUsageList(pageTypefilter, 'Pages Usage', unboundVisitPage)}
        {separateUsageList(componentTypefilter, 'Containers Usage', unboundVisitComponent)}
      </div>
    );
  };

  return <div key={shortid.generate()}>{renderUsageList()}</div>;
};

ComponentUsage.propTypes = {
  usage: propTypes.shape(),
  unboundVisitComponent: propTypes.func.isRequired,
  unboundVisitPage: propTypes.func.isRequired
};

ComponentUsage.defaultProps = {
  usage: {}
};

export default ComponentUsage;
